import React from "react";
import { Container } from "reactstrap";
import BreadCrumb from "Components/Common/BreadCrumb";

const DashboardEcommerce = () => {

  document.title = "Dashboard | Qdos";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={"Products"} pageTitle={"Dashboard"} />
          
          {/* Your existing dashboard content would go here */}
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <h4 className="card-title">Dashboard</h4>
                  <p className="text-muted">Welcome to the Qdos Dashboard</p>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DashboardEcommerce;
